import * as wjCore from '@mescius/wijmo'
import * as wjGrid from '@mescius/wijmo.grid'
import { Menu } from '@mescius/wijmo.input'
import * as wjcXlsx from '@mescius/wijmo.xlsx'
import { FlexGridXlsxConverter } from '@mescius/wijmo.grid.xlsx'
import * as utility from '../utility'
import moment from 'moment'

function arrayToCsv (array, tableFormat) {
  const header = tableFormat.map((col) => col.text).join(',') + '\n'
  const body = array.map(
    (elem) => tableFormat.map((col) => {
      const value = utility.getWithDot(elem, col.field) // elem[col.field]
      return typeof value === 'string' && value.match(/[,\t\n]/) ? `"${value.replaceAll('"', "'")}"` : value
    }).join(',')
  ).join('\n')
  return header + body
}

export default function customContextMenu (grid) {
  const host = grid.hostElement
  const exportPath = moment().format('YYYY-MM-DD-HHmmss')
  const menu = new Menu(document.createElement('div'), {
    owner: host,
    displayMemberPath: 'header',
    subItemsPath: 'items',
    commandParameterPath: 'cmd',
    dropDownCssClass: 'ctx-menu',
    openOnHover: false,
    closeOnLeave: true,
    itemsSource: [
      { header: 'コピー', cmd: 'COPY' },
      { header: 'ペースト', cmd: 'PASTE' },
      { header: '-' },
      { header: '列幅の自動調整', cmd: 'ASZ' },
      { header: 'すべての列幅の自動調整', cmd: 'ASZ_ALL' },
      { header: '-' },
      { header: 'エクスポート（CSV）', cmd: 'X_CSV' },
      { header: 'エクスポート（Excel）', cmd: 'X_XLSX' }
    ],
    command: {
      // enable/disable menu commands
      canExecuteCommand: (cmd) => {
        // const view = grid.collectionView; const col = grid.columns[grid.selection.col]
        switch (cmd) {
          case 'ASZ':
          case 'ASZ_ALL':
            return true
        }
        return true
      },
      // execute menu commands
      executeCommand: (cmd) => {
        // const view = grid.collectionView
        const cols = grid.columns
        const col = cols[grid.selection.col]
        switch (cmd) {
          case 'COPY':
            utility.clipboardCopy(
              grid.getClipString(
                grid.selectedRanges[0],
                wjGrid.ClipStringOptions.Default,
                false, false
              )
            )
            break
          case 'PASTE':
            utility.getClipboard((data) => {
              if (data) {
                grid.setClipString(data)
              }
            })
            break
          case 'ASZ':
            grid.autoSizeColumn(col.index)
            break
          case 'ASZ_ALL':
            grid.autoSizeColumns(0, grid.columns.length - 1)
            break
            // export
          case 'X_CSV': {
            let content = ''
            const items = grid.collectionView.items.filter((item) => !item.exclude_from_export)
            if (grid.tableFormat) {
              content = arrayToCsv(items, grid.tableFormat)
            } else {
              content = grid.getClipString(
                new wjGrid.CellRange(0, 0, grid.rows.length - 1, grid.columns.length - 1),
                wjGrid.ClipStringOptions.CSV,
                true, false
              )
            }
            wjCore.saveFile(
              content,
              exportPath + '.csv'
            )
            break
          }
          case 'X_XLSX': {
            if (grid.tableFormat) {
              const book = new wjcXlsx.Workbook()
              const sheet = new wjcXlsx.WorkSheet()
              book.sheets.push(sheet)
              sheet.rows[0] = new wjcXlsx.WorkbookRow()
              grid.tableFormat.forEach((col, i) => {
                sheet.rows[0].cells[i] = new wjcXlsx.WorkbookCell()
                sheet.rows[0].cells[i].value = col.text
              })
              const items = grid.collectionView.items.filter((item) => !item.exclude_from_export)
              items.forEach((item, j) => {
                sheet.rows[j + 1] = new wjcXlsx.WorkbookRow()
                grid.tableFormat.forEach((col, i) => {
                  sheet.rows[j + 1].cells[i] = new wjcXlsx.WorkbookCell()
                  sheet.rows[j + 1].cells[i].value = utility.getWithDot(item, col.field)
                  if (col.field === 'rate_decimal') {
                    sheet.rows[j + 1].cells[i].style = new wjcXlsx.WorkbookStyle()
                    sheet.rows[j + 1].cells[i].style.format = wjcXlsx.Workbook.toXlsxNumberFormat('P2')
                  }
                })
              })

              book.saveAsync(exportPath)
            } else {
              FlexGridXlsxConverter.saveAsync(grid, null, exportPath + '.xlsx')
            }
            break
          }
        }
        // restore focus to active grid cell (TFS 439964)
        grid.refresh()
        const sel = grid.selection; const cell = grid.cells.getCellElement(sel.row, sel.col)
        if (cell) {
          cell.focus()
        }
      }
    }
  })
  host.addEventListener('contextmenu', (e) => {
    const sel = grid.selection
    const ht = grid.hitTest(e)
    // const row = ht.getRow()
    switch (ht.panel) {
      case grid.cells:
        /*
        {
          let colIndex = ht.col
          // if this is a group header, select the group column
          if (row instanceof GroupRow && row.dataItem instanceof wjCore.CollectionViewGroup) {
            const gd = row.dataItem.groupDescription
            if (gd instanceof wjCore.PropertyGroupDescription) {
              const col = grid.getColumn(gd.propertyName)
              if (col && col.index > -1) {
                colIndex = col.index
              }
            }
          }
          grid.select(ht.row, colIndex)
        }
        */
        break
      case grid.columnHeaders:
        grid.select(sel.row, ht.col)
        break
      case grid.rowHeaders:
        grid.select(ht.row, sel.col)
        break
      default:
        return // invalid panel
    }
    // show the menu for the current column
    if (grid.selection.col > -1) {
      e.preventDefault() // cancel the browser's default menu
      menu.show(e) // and show ours
    }
  }, true)
}
